import i18n from "i18next";
import { type FC, useCallback } from "react";
import { useDispatch } from "react-redux";

import type { SiteList } from "src/app/features/Site/types/SiteList";
import { SecondaryButton } from "../../../../../components/Buttons/components/ActionButton";
import type { ButtonProps } from "../../../../../components/FeatureButtons/types";
import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { showSuccessNotification } from "../../../../../core/setup/redux/state/notifications/notificationsState";
import { useSiteFinishDealerChangeMutation } from "../../services/server/SiteApi";

export const FinishDealerChangeButton: FC<ButtonProps<SiteList>> = ({ item, items }) => {
    const dispatch = useDispatch();

    const dataGroup = getAssignedDataGroup();

    const [finishDealerChange] = useSiteFinishDealerChangeMutation();

    const onClick = useCallback(async () => {
        const result = await finishDealerChange({ data: item as SiteList });

        const hasError = "error" in result;
        if (!hasError) {
            dispatch(
                showSuccessNotification({
                    text: i18n.t("common.finishDealerChange", {
                        id: result.data.id,
                        resource: "Site",
                    }),
                    autoCloseDisabled: false,
                }),
            );
        }
    }, [dispatch, finishDealerChange, item]);

    let disabled = true;
    if (items && item) {
        disabled = !(items.length === 1 && item.status === "DEALER_CHANGE");
    }

    const showButton = dataGroup.dealerChangeProcessing === "MANUAL";

    return (
        showButton && (
            <SecondaryButton onClick={onClick} disabled={disabled}>
                {i18n.t("button.finishDealerChange")}
            </SecondaryButton>
        )
    );
};
